import type {CompRef, Pointer} from '@wix/document-services-types'
import {createHookDefinition} from '../../utils/hooksUtils'
import type {HookEventData} from '../hooks/hooks'
import type {FeatureData} from '../features/features'
import type {DalItem} from '@wix/document-manager-core'

export interface GetItemQueryIdData {
    compPointer: CompRef
    propName: string
}
export interface FeatureDataUpdate {
    compPointer: Pointer
    featureName: string
    featureData: FeatureData
}

export interface GetQueryIdEvent extends GetItemQueryIdData, HookEventData<'get_query_id'> {}
export interface FeatureDataUpdatedEvent extends FeatureDataUpdate, HookEventData<'after_feature_data_update'> {}

export interface BeforeGetRepeatedPointer {}

export interface DeserializeDataItem {
    deserializedDataItem: DalItem
    itemType: string
    itemId: string
    oldToNewIdMap?: Record<string, string>
}
export interface DeserializeDataItemEvent extends DeserializeDataItem, HookEventData<'after_deserialize_data_item'> {}

export interface BeforeGetRepeatedPointerEvent
    extends BeforeGetRepeatedPointer,
        HookEventData<'before_get_repeated_pointer'> {}

export interface AfterPublicGetDataItem {
    componentPointer: Pointer
    dataItem: any
}
export interface AfterPublicGetDataItemEvent extends AfterPublicGetDataItem, HookEventData<'after_get_data_public'> {}

export interface BeforePublicUpdateDataItem {
    componentPointer: Pointer
    dataItem: any
}
export interface BeforePublicUpdateDataItemEvent
    extends BeforePublicUpdateDataItem,
        HookEventData<'data_update_before_public'> {}

export interface InnerElementDataUpdateBefore {
    componentPointer: CompRef
    dataItem: any
}

export const DATA_MODEL_HOOKS = {
    DATA: {
        AFTER_GET_PUBLIC: createHookDefinition<'after_get_data_public', AfterPublicGetDataItem>(
            'after_get_data_public'
        ),
        BEFORE_UPDATE_PUBLIC: createHookDefinition<'data_update_before_public', BeforePublicUpdateDataItem>(
            'data_update_before_public'
        ),
        INNER_ELEMENT_UPDATE_BEFORE: createHookDefinition<
            'inner_element_data_update_before',
            InnerElementDataUpdateBefore
        >('inner_element_data_update_before')
    },
    NAMESPACE_ITEM: {
        GET_QUERY_ID: createHookDefinition<'get_query_id', GetItemQueryIdData>('get_query_id')
    },
    GET_REPEATED_ITEM_POINTER: {
        BEFORE: createHookDefinition<'before_get_repeated_pointer', BeforeGetRepeatedPointer>(
            'before_get_repeated_pointer'
        )
    },
    FEATURE_DATA_UPDATE: {
        AFTER: createHookDefinition<'after_feature_data_update', FeatureDataUpdate>('after_feature_data_update')
    },
    SERIALIZE: {
        DATA_ITEM_AFTER: createHookDefinition<'after_serialize_data_item', {dataItem: DalItem}>(
            'after_serialize_data_item'
        )
    },
    DESERIALIZE: {
        DATA_ITEM_AFTER: createHookDefinition<'after_deserialize_data_item', DeserializeDataItem>(
            'after_deserialize_data_item'
        )
    }
}
